import * as React from 'react';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import {
  DataGrid,
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  ExportCsv,
  ExportPrint,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
  QuickFilterTrigger,
} from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import Badge from '@mui/material/Badge';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { DataContext } from '.';
import { Button } from '@mui/material';
import clsx from "clsx";
import { TailwindDemoContainer } from '@mui/x-data-grid/internals';


// function Button(props) {
//   return (
//     <button
//       type="button"
//       {...props}
//       className={clsx(
//         'flex h-9 items-center justify-center rounded border border-neutral-200 cursor-pointer dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-900 px-2.5 text-sm font-bold text-neutral-700 dark:text-neutral-200 whitespace-nowrap select-none hover:bg-neutral-100 dark:hover:bg-neutral-800 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-600 active:bg-neutral-100 dark:active:bg-neutral-700',
//         props.className,
//       )}
//     />
//   );
// }

function TextInput(props) {
  return (
    <input
      {...props}
      className={clsx(
        'h-9 w-full rounded border border-neutral-200 dark:border-neutral-700 dark:bg-neutral-900 px-2.5 text-base text-neutral-900 dark:text-neutral-200 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600',
        props.className,
      )}
    />
  );
}

const StyledQuickFilter = styled(QuickFilter)({
  display: 'grid',
  alignItems: 'center',
});

const StyledToolbarButton = styled(ToolbarButton)(({ theme, ownerState }) => ({
  gridArea: '1 / 1',
  width: 'min-content',
  height: 'min-content',
  zIndex: 1,
  opacity: ownerState.expanded ? 0 : 1,
  pointerEvents: ownerState.expanded ? 'none' : 'auto',
  transition: theme.transitions.create(['opacity']),
}));

const StyledTextField = styled(TextField)(({ theme, ownerState }) => ({
  gridArea: '1 / 1',
  overflowX: 'clip',
  width: ownerState.expanded ? 260 : 'var(--trigger-width)',
  opacity: ownerState.expanded ? 1 : 0,
  transition: theme.transitions.create(['width', 'opacity']),
}));



function CustomToolbar() {
  return (
    <Toolbar className="gap-2! p-2!">
      <ColumnsPanelTrigger
        render={<ToolbarButton render={<Button>Columns</Button>} />}
      />
      <FilterPanelTrigger
        render={<ToolbarButton render={<Button>Filter</Button>} />}
      />
      {/* <ExportCsv render={<ToolbarButton render={<Button>Export</Button>} />} />
      <ExportPrint render={<ToolbarButton render={<Button>Print</Button>} />} /> */}
      <QuickFilter
        render={(props, state) => (
          <div {...props} className="ml-auto flex overflow-clip">
            <QuickFilterTrigger
              className={state.expanded ? 'rounded-r-none border-r-0' : ''}
              render={
                <ToolbarButton
                  render={
                    <Button aria-label="Search">
                      <SearchIcon fontSize="small" />
                    </Button>
                  }
                />
              }
            />
            <div
              className={clsx(
                'flex overflow-clip transition-all duration-300 ease-in-out',
                state.expanded ? 'w-48' : 'w-0',
              )}
            >
              <QuickFilterControl
                aria-label="Search"
                placeholder="Search"
                render={({ slotProps, size, ...controlProps }) => (
                  <TextInput
                    {...controlProps}
                    {...slotProps?.htmlInput}
                    className={clsx(
                      'flex-1 rounded-l-none',
                      state.expanded && state.value !== '' && 'rounded-r-none',
                    )}
                  />
                )}
              />
              {state.expanded && state.value !== '' && (
                <QuickFilterClear
                  render={
                    <Button aria-label="Clear" className="rounded-l-none">
                      <CancelIcon fontSize="small" />
                    </Button>
                  }
                />
              )}
            </div>
          </div>
        )}
      />
    </Toolbar>
  );
}


export default function GridToolbar() {
//   const { data, loading } = useDemoData({
//     dataSet: 'Commodity',
//     rowLength: 10,
//     maxColumns: 10,
//   });
     const rows = React.useContext(DataContext);

const columns = [
    {
          field: "id",
          headerName: "ID",
          width: 80,
          headerAlign: "center",
          align: "center",
          renderCell: (params) => {
            console.log('', params);
            return (
              <Link
                to={`/view-value`}
                // to={`/view-event/${params.value}`}
                style={{ textDecoration: "underline", color: "black" }}
              >
                {params.value}
              </Link>
            );
          },
        },
        {
          field: "name",
          headerName: "Group",
          width: 150,
          flex: 1,
          headerAlign: "center",
          align: "center",
        },
        {
            field: "startDate",
            headerName: "Start Date",
            minWidth: 150,
            flex: 1,
            type: "date",
        },
        {
            field: "endDate",
            headerName: "End Date",
            minWidth: 150,
            flex: 1,
            type: "date",
        },
  ]
const documentBody = typeof window !== "undefined" ? window.document.body : undefined;

  return (
    <div style={{ height: 400, width: '100%' }}>
      

      {/* <ThemeProvider theme={theme}> */}
              <TailwindDemoContainer documentBody={documentBody}>
                <DataGrid
                    columns={columns}
                    rows={rows}
                    slots={{ toolbar: CustomToolbar }}
                    showToolbar
                />
              </TailwindDemoContainer>
            {/* </ThemeProvider> */}
    </div>
  );
}
